import script from "./DriverDeliveries.vue?vue&type=script&setup=true&lang=js"
export * from "./DriverDeliveries.vue?vue&type=script&setup=true&lang=js"

import "./DriverDeliveries.vue?vue&type=style&index=0&id=6bbbf01c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bbbf01c"]])

export default __exports__